export interface ExternalNavItem {
  to: string
  label: string
}

export const defaultExternalNavItems: ExternalNavItem[] = [
  // { to: '/login', label: 'Log in' },
  // { to: '/signup', label: 'Sign up' },
]
